<template lang="pug">
  .burger.js-burger
    span.burger__bar.burger__bar1
    span.burger__bar.burger__bar2
    span.burger__bar.burger__bar3
    span.burger__bar.burger__bar4
    span.burger__bar.burger__bar5

</template>

<script>
//import '@/components/common/burger/burger.styl';

//import EventBus from '@/eventBus';
//import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import {CommonHelpersVue} from '@/mixins/CommonHelpersVue';

export default {
  name: 'Burger',

  mixins: [CommonHelpersVue],

  data() {
    return {

    }
  },

  components: {
    //SvgIcon
  },

  created() {
    this.$nextTick(() => {
      this.burgerInit();
    });
  },

  methods: {
    burgerInit() {
      let that = this;

      $(document).on('click', '.js-burger', function() {
        $(this).toggleClass('burger--open');
        $('.menu-left').toggleClass('menu-left--mobile-open');

        that.closeMenuPageMenu();
      });
    }
  }

}
</script>
